import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const AboutUs = () => {

    useEffect(() => {
      window.scrollTo(0, 0); // Scroll to top when component is mounted
    }, []);
  return (
    <Container>
      <div class="privacy_text">
        <h2>FindMe: About Us</h2>
        <h4>
        Welcome to ‘FindMe’,
<br/>Your all-in-one job and hiring app!
        </h4>
        <p>
        Here, we’re on a mission to make job searching and hiring easier, faster, 
        and more trusted for everyone. At FindMe, whether you’re someone looking 
        for a job or a business owner searching for reliable workers, this 
        application is built to connect the right people at the right time.
        </p>

        <h5>For Job Seekers:</h5>
        <p>
        We know how tough it can be to find the right opportunity. That’s why 
        FindMe helps you search for nearby jobs, apply directly, and showcase 
        your skills through your profile. No long forms or confusing steps – 
        just simple and quick access to jobs that match your needs.
        </p>
        <h5>For Businesses:</h5>
        <p>Hiring the right person shouldn't be difficult. By using our mobile 
            app, you can post job openings, review applicant profiles, and 
            connect with potential workers without delay. Whether you're looking 
            for part-time help or building a team, we've made it easier for you.</p>
        
        <h4>Why Choose FindMe?</h4>
        <ul>
          <li>Easy to use interface</li>
          <li>
          Real-time job and worker listings
          </li>
          <li>
          Profile-based matching
          </li>
          <li>
          Location-based search
          </li>
          <li>
          Secure and verified accounts
          </li>
        </ul>
        <p>
        We believe in building a trusted and supportive space where people can 
        find honest work and businesses can grow with the right talent. Every 
        connection matters, and that’s what drives us.
        </p>

        <p>
        So, whether you're finding work or building your dream team — <b>‘FindMe’</b> is 
        here to help you every step of the way.
        </p>
        <p>
        Let’s connect, grow, and succeed together! Download the app and start your journey today!
        </p>

      </div>
    </Container>
  );
};

export default AboutUs;
